export const cartas= [{
  name: "Ariana Grande Tour",
   artist :"Ariana Grande",
   place :"Gran Rex",
   address:"Corrientes 857",
   location:"San Nicolas",
   province:"Capital Federal",
   price: 800,
   availableTickets: 140,
   image:"https://cdn.boletius.com/images/1497890220613-test-pos-arian-1920x720-min.jpg",
   time:"20:00",
   isImportant: false,
   category: 1,
   subCategories: ["Pop"],
   date: "31/12/2021"

}, {
   name: "Symphony and Destruction",
   artist:"Megadeath",
   place:"Teatro Vorterix",
   address:"Federico Lacroze 3455",
   location:"Colegiales",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://megadeth.com/wp-content/uploads/2019/05/BuenosAires2019.jpg",
   time:"22:00",
   isImportant: true,
   category: 1,
   subCategories: ["Rock"],
   date: "1/03/2022"

}, {
   name: "Meteora",
   artist:"Linkin Park",
   place:"Teatro Mercedes Sosa",
   address:"San Martin 479",
   location:"San Miguel De Tucuman",
   province:"Tucuman",
   price: 900,
   availableTickets: 1100,
   image:"http://www.georgeamphitheatre.com/wp-content/uploads/2014/09/linkin-banner.png",
   time:"18:00",
   isImportant: true,
   category: 1,
   subCategories: ["Rock", "Pop"],
   date: "16/10/2022"
}, {
   name: "Con Eso SI Se Jode",
   artist:"Matias Bottero",
   place:"Teatro Real",
   address:"San Jeronimo 66",
   location:"Cordoba",
   province:"Cordoba",
   price: 800,
   availableTickets: 140,
   image:"https://www.mgdifusion.com.ar/wp-content/uploads/2021/05/Con-eso-si-se-jode.jpg",
   time:"19:00",
   isImportant: false,
   category: 2,
   subCategories: ["Comedia","'Unipersonal'","'Stand Up'","'Absurdo'"],
   date: "09/07/2022"
}, {
   name: "Hamlet",
   artist:"Shakespeare",
   place:"Teatro La Kanoa De Papel",
   address:"Dr. Juan Olsacher 2680",
   location:"La Rioja",
   province:"La Rioja",
   price: 800,
   availableTickets: 140,
   image:"https://www.glenville.edu/sites/default/files/RM%20Hamlet%20Page%20Banner.jpg",
   time:"14:00",
   isImportant: false,
   category: 2,
   subCategories: ["Drama"],
   date: "03/08/2022"
},
{
   name: "The Pepo Show",
   artist:"El Pepo",
   place:"Sala 88 Coperativa De Teatro",
   address:"French 845",
   location:"Resistencia",
   province:"Chaco",
   price: 600,
   availableTickets: 400,
   image:"https://scontent.ftuc1-2.fna.fbcdn.net/v/t1.6435-9/37373467_1077054085782815_8150729415244906496_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=730e14&_nc_ohc=uV1cGtYKkuYAX_hzuEM&_nc_ht=scontent.ftuc1-2.fna&oh=551d1c4653190e1c69e31ab1f7e3c2e0&oe=618152D9",
   time:"16:00",
   isImportant: false,
   category: 1,
   subCategories: ["Cumbia"],
   date: "15/08/2022"
},{
   name: "L-Gante KLoKE Show",
   artist:"L-Gante",
   place:"El Arrimadero",
   address:"Misiones 234",
   location:"Neuquen",
   province:"Neuquen",
   price: 900,
   availableTickets: 700,
   image:"https://scontent.ftuc1-2.fna.fbcdn.net/v/t1.6435-9/210956194_2490923391051828_3258569032312035991_n.jpg?_nc_cat=111&ccb=1-5&_nc_sid=8bfeb9&_nc_ohc=U1f3tEwJRqMAX-SPVC0&_nc_ht=scontent.ftuc1-2.fna&oh=89814411cd3cf2650461125dbe7cbe29&oe=617F8E4C",
   time:"23:00",
   isImportant: false,
   category: 1,
   subCategories: ["Cumbia", "Reggaeton"],
   date: "17/11/2021"
},{
   name: "The Skrillex Tour",
   artist:"Skrillex",
   place:"Teatro El Pasillo",
   address:"José de la Iglesia 1190",
   location:"San Salvador de Jujuy",
   province:"Jujuy",
   price: 1200,
   availableTickets: 500,
   image:"https://imgproxy.ra.co/_/quality:100/plain/https://static.ra.co/images/events/flyer/2016/3/us-0302-818324-front.jpg?dateUpdated=1458120621230",
   time:"00:00",
   isImportant: false,
   category: 1,
   subCategories: ["Electronica"],
   date: "25/12/2021"
},/////////////////////////////////
{
   name: "Buena vida",
   artist:"Diego Torres",
   place:"Teatro Vorterix",
   address:"Federico Lacroze 3455",
   location:"Colegiales",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://www2.baccredomatic.com/sites/default/files/gt_banner_desktop_diego_torres_0819.jpg",
   time:"22:00",
   isImportant: false,
   category: 1,
   subCategories: ["Rock"],
   date: "21/09/2022"

},
{
   name: "PZK",
   artist:"Tiago",
   place:"Teatro Vorterix",
   address:"Federico Lacroze 3455",
   location:"Colegiales",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://i2.wp.com/urbanroosters.news/wp-content/uploads/2019/07/tiago-banner.jpg",
   time:"22:00",
   isImportant: false,
   category: 1,
   subCategories: ["Trap"],
   date: "21/09/2022"

},
{
   name: "13",
   artist:"Black Sabbath",
   place:"Luna Park",
   address:"Av. Eduardo Madero 470",
   location:"San Nicolas",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://maxmetal.net/40/wp-content/uploads/2020/03/ozzy-osbourne-ordinary-man-banner-ok-1078x516.jpg",
   time:"22:00",
   isImportant: true,
   category: 1,
   subCategories: ["Rock"],
   date: "1/03/2022"

},
{
   name: "Papi Lounge",
   artist:"Maluma",
   place:"Teatro Vorterix",
   address:"Federico Lacroze 3455",
   location:"Colegiales",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://maluma.online/wp-content/uploads/2021/07/Papi-Lounge-VIP-sp.jpg",
   time:"24:00",
   isImportant: false,
   category: 1,
   subCategories: ["Cumbia", "Reggaeton"],
   date: "1/03/2022"

},
{
   name: "LOCOPLAYA",
   artist:"Don Patricio",
   place:"Teatro Vorterix",
   address:"Federico Lacroze 3455",
   location:"Colegiales",
   province:"Capital Federal",
   price: 1000,
   availableTickets: 1440,
   image:"https://cdn.boletius.com/images/1568665182110-1920-720-locoplaya-vtx_%281%29.jpg",
   time:"22:00",
   isImportant: true,
   category: 1,
   subCategories: ["Trap"],
   date: "1/03/2022"

},
{
   name: "Permiso",
   artist:"Jose Larralde",
   place:"Cosquin",
   address:"Plaza Prospero Molina",
   location:"Cosquin",
   province:"Cordoba",
   price: 1000,
   availableTickets: 1440,
   image:"http://3.bp.blogspot.com/-qeRVFqYQCC4/WdujDg1zJCI/AAAAAAAAXlU/gkov0O42kbkW1c2t6Ho8H4QGWoTep7PQgCK4BGAYYCw/s1600/TAPA.JPG",
   time:"22:00",
   isImportant: true,
   category: 1,
   subCategories: ["Rock"],
   date: "1/03/2022"

},]